import { store } from '../store';
import { logout } from '../store/authSlice';
import secureStorage from './secureStorage';

/**
 * If a session exists, calls DELETE /auth/logout (via logout thunk) and clears client state
 * before starting another sign-in / sign-up that would replace the session.
 * Safe to call when already logged out (no-op).
 */
export async function ensureLoggedOutBeforeNewAuth(): Promise<void> {
  if (!secureStorage.getToken()) return;
  await store.dispatch(logout());
}
